<template>
  <div class="animated fadeIn" id="list-justificatifs">
        <transition name="fade">
          <b-card no-body>
            <div slot="header">
              <i class="fa fa-search mr-2"></i>
              <strong>Recherche</strong>
              <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <span class="when-opened">
                    <i class="icon-arrow-down"></i>
                  </span>
                  <span class="when-closed">
                    <i class="icon-arrow-up"></i>
                  </span>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <b-alert show variant="danger" v-if="errors.noCriteria !== ''">
                  {{ errors.noCriteria }}
                </b-alert>
                <b-form v-on:submit.prevent="searchByFilters">
                  <b-row>
                    <b-col sm="4">
                      <b-form-group >
                        <label for="num_dossier"><strong>N° Dossier</strong></label>
                        <b-form-input type="text" id="num_dossier" v-model="num_dossier" :class="{hasError: errors.num_dossier !== ''}"></b-form-input>
                        <span class="field-error">{{ errors.num_dossier }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group >
                        <label for="num_nsi"><strong>N°Identifiant NSI</strong></label>
                        <b-form-input type="text" id="num_nsi" v-model="num_nsi" :class="{hasError: errors.num_nsi !== ''}"></b-form-input>
                        <span class="field-error">{{ errors.num_nsi }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group >
                        <label for="nir"><strong>N° Sécurité Sociale</strong></label>
                        <b-form-input type="text" id="nir" v-model="nir"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group >
                        <label for="nom"><strong>Nom</strong></label>
                        <b-form-input type="text" id="nom" v-model="nom"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group >
                        <label for="prenom"><strong>Prénom</strong></label>
                        <b-form-input type="text" id="prenom" v-model="prenom"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                       <b-form-group>
                          <label for="statut"><strong>Statut</strong></label>
                          <b-form-radio-group id="statut" v-model="statut">
                            <b-form-radio value="tous">Tous</b-form-radio>
                            <b-form-radio value="en_attente">En attente</b-form-radio>
                            <b-form-radio value="envoye">Envoyé</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="2">
                      <b-form-group>
                        <label for="date_du"><strong>Période du</strong></label>
                        <b-form-input type="date" id="date_du" v-model="date_du"></b-form-input>
                        <span class="field-error">{{ errors.date_du }}</span>
                      </b-form-group>
                    </b-col>
                    <b-col sm="2">
                      <b-form-group>
                        <label for="date_au"><strong>Au</strong></label>
                        <b-form-input type="date" id="date_au" v-model="date_au"></b-form-input>
                        <span class="field-error">{{ errors.date_au }}</span>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div slot="footer">
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                      <i class="fa fa-eraser"></i> Effacer
                    </b-button>
                    <b-button type="enter" @click.prevent="searchByFilters()" size="md" variant="primary">
                      <i class="fa fa-search"></i> Rechercher
                    </b-button>
                  </div>
                </b-form>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Justificatifs</strong>
      </b-card-header>
      <b-card-body>
        <justificatif-table :tableEntry="tableParam" ref="justificatif_table" :statusTab="status"></justificatif-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import downloadFile from '@/utils/fileHelper'
import JustificatifTable from '../../components/JustificatifTable'
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
  components: { JustificatifTable },
  data() {
    return {
      num_nsi : '',
      num_dossier : '',
      date_du : '',
      date_au : '',
      nir: '',
      nom: '',
      prenom: '',
      statut: 'envoye',
      noSearch: 'noSearch',
      status: [],
      defaultItems : [],
      errors: { 
        noCriteria: '',
        num_nsi: '',
        num_dossier: '',
        date_du: '',
        date_au: '',
        nir: '',
        nom: '',
        prenom: ''
      },
      fr: fr,
      DatePickerFormat: 'dd/MM/yyyy'
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  computed: {
    tableParam: {
      get() {
        let request = {};

        request.num_nsi = this.num_nsi.replace(/ /g, "")
        this.num_nsi = request.num_nsi
        request.num_dossier = this.num_dossier.replace(/ /g, "")
        this.num_dossier = request.num_dossier
        request.nir = this.nir.replace(/ /g, "")
        this.nir = request.nir
        request.date_du = this.date_du;
        request.date_au = this.date_au;
        request.nom = this.nom;
        request.prenom = this.prenom;
        request.statut = this.statut;
        request.noSearch = this.noSearch;
        
        return request;
      }
    },
  },
  methods: {
    showFiche(dossierId) {
      this.$router.push({ path: '/espace-beneficiaire/justificatifs/' + dossierId })
    },
    searchByFilters() {
      if (this.validateData()) {
        this.noSearch = ''
        this.$refs.justificatif_table.$refs.table.refresh()
      }
    },
    validateData() {
      this.clearErrors()
      let dateFrom = new Date(this.date_du)
      let dateTo = new Date(this.date_au)
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true
      let num_nsi = this.num_nsi.replace(/ /g, "")
      if (num_nsi !== '') {
        if (!regNumeric.test(num_nsi)) {
          this.errors.num_nsi = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
          valid = false
        }
        else if (num_nsi.length > 9 || num_nsi.length < 9) {
          this.errors.num_nsi = 'Un N°Identifiant NSI doit contenir exactement 9 chiffres'
          valid = false
        }
      }

      let num_dossier = this.num_dossier.replace(/ /g, "")
      if (num_dossier !== '' && !regNumeric.test(num_dossier)) {
        this.errors.num_dossier = 'Un N° Dossier ne doit contenir que des chiffres'
        valid = false
      }

      let nir = this.nir.replace(/ /g, "")
      if (nir !== '') {
        if (!regNumeric.test(nir)) {
          this.errors.nir = 'Un N° de Sécurité Sociale ne doit contenir que des chiffres'
          valid = false
        }
        else if (nir.length > 13 || nir.length < 13) {
          this.errors.nir = 'Un N° de Sécurité Sociale  doit contenir exactement 13 chiffres'
          valid = false
        }
      }

      if (this.date_au !== null && this.date_au !== "") {
        if (dateTo.getTime() < dateFrom.getTime()) {
          this.errors.date_au = "La date de fin doit être postérieure à la date de début";
          valid= false;
        }
      }

      return valid
    },
    clearErrors() {
      this.errors.noCriteria = ''
      this.errors.num_nsi = ''
      this.errors.num_dossier = ''
      this.errors.date_du = ''
      this.errors.date_au = ''
      this.errors.nir = ''
    },
    clearForm() {
      this.num_nsi = '' 
      this.num_dossier = ''
      this.date_du = ''
      this.date_au = ''
      this.prenom = ''
      this.nom = ''
      this.nir = ''
      this.statut = 'envoye'
    }
  }
};
</script>

<style>
  .modal-dialog {
    max-width: 800px;
    height: 750px;
    margin: 1.75rem auto;
  }
  .modal-body {
    min-height: 750px;
  }
  .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
  } 
 
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:first-child {
  width: 7%;
}
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:nth-child(2) {
  width: 10%;
}
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:nth-child(3) {
  width: 10%;
}
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:nth-child(4) {
  width: 29%;
}
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:nth-child(5) {
  width: 29%;
}
#list-justificatifs .VueTables__table thead tr:not(.child_row) th:nth-child(6) {
  width: 15%;
}

#list-justificatifs .VueTables__table thead tr.child_row th:first-child {
  width: 30%;
}
#list-justificatifs .VueTables__table thead tr.child_row th:nth-child(2) {
  width: 25%;
}
#list-justificatifs .VueTables__table thead tr.child_row th:nth-child(3) {
  width: 20%;
}
#list-justificatifs .VueTables__table thead tr.child_row th:nth-child(4) {
  width: 10%;
}
#list-justificatifs .VueTables__table thead tr.child_row th:nth-child(5) {
  width: 10%;
}
#list-justificatifs .VueTables__table thead tr.child_row th:nth-child(6) {
  width: 5%;
}
</style>